module.exports = __webpack_public_path__ + "static/media/fun16.72418248.png";